<template>
  <div class="content">
    <div class="container">
      <div class="floating-buttons">
        <button :disabled="hasSelect()" class="fl-button" @click="popup.import = true" title="Importálás Excel fájlból">
          <i class="fa fa-file-excel"></i>
        </button>
        <button :disabled="hasSelect()" class="fl-button" @click="save" title="Mentés">
          <i class="fa fa-save"></i>
        </button>
        <button v-if="hasSelect()" class="fl-button" @click="mail" title="Email küldés">
          <i class="fa fa-envelope"></i>
        </button>
      </div>

      <h1>Vonalkód beállítás</h1>

      <div v-if="barcodes.length > 0" class="table-with-title">
        <table class="list">
          <tr>
            <th>
              <checkbox :disabled="!visibleAllSelect()" key="all_select" id="all_select" v-model="all_select"/>
            </th>
            <th>Rf ID / Szám</th>
            <th>Név / Email</th>
            <th>Rendszám</th>
            <th>Jog</th>
            <th>Kezdő dátum</th>
            <th>Időtartam (óra)</th>
          </tr>

          <tr>
            <td valign="top">

            </td>
            <td valign="top">

            </td>
            <td valign="top">

            </td>
            <td valign="top">

            </td>
            <td valign="top">
              <checkbox style="padding-bottom: 5px" @input="allAccessLevelChange" v-for="al in access_levels" :label="al.name" name="all_access_level_id[]" :id="'all_access_level_id_'+al.id" :val="al.id" v-model="all_access_level_id"/>
            </td>
            <td valign="top">
              <inputbox @input="allStartDateTimeChange" :datepicker="{enableTime: true}" style="width: 150px" label="" key="all_start_date_time" id="all_start_date_time" v-model="all_start_date_time" />
            </td>
            <td valign="top">
              <inputbox v-if="$root.user.barcode_period_fix == 0" @input="allPeriodChange" style="width: 60px" regexp_filter="[0-9]+" label="" key="all_period" id="all_period" v-model="all_period" />
            </td>
          </tr>

          <tr v-for="barcode in barcodes">
            <td valign="top">
              <checkbox :disabled="!barcode.email_can_be_sent" :key="'barcode_selected_'+barcode.id" :id="'barcode_selected_'+barcode.id" val="1" v-model="barcode.selected"/>
            </td>
            <td valign="top"><span style="font-size: 10px">{{ barcode.rf_id }}</span><br>{{ barcode.barcode_number }}<div v-if="barcode.email_sent == 1"><i class="fa fa-envelope"></i> <span style="font-size: 10px">{{ barcode.email_sent_user_name }} ({{ barcode.email_sent_user_email }})</span></div></td>
            <td valign="top">
              <inputbox @input="barcode.email_can_be_sent = false; barcode.selected = false; all_select = false;" :disabled="!barcode.editable" placeholder="Kedvezményezett neve" style="width: 200px; padding-bottom: 0px;" :errors="errors" label="" :key="'barcode_name_'+barcode.id" :id="'barcode_name_'+barcode.id" v-model="barcode.name" />
              <inputbox @input="barcode.email_can_be_sent = false; barcode.selected = false; all_select = false;" :disabled="!barcode.editable" placeholder="Kedvezményezett email címe" style="width: 200px" :errors="errors" label="" :key="'barcode_email_'+barcode.id" :id="'barcode_email_'+barcode.id" v-model="barcode.email" />
            </td>
            <td valign="top">
              <inputbox @input="barcode.email_can_be_sent = false; barcode.selected = false; all_select = false;" :disabled="!barcode.editable" style="width: 100px" regexp_filter="[0-9a-zA-Z]+" :errors="errors" label="" :key="'barcode_license_plate_'+barcode.id" :id="'barcode_license_plate_'+barcode.id" v-model="barcode.license_plate" />
            </td>
            <td valign="top">
              <checkbox @input="barcode.email_can_be_sent = false; barcode.selected = false; all_select = false;" style="padding-bottom: 5px" :disabled="!barcode.editable" v-for="al in access_levels" :label="al.name" :name="'barcode_access_levels_'+barcode.id+'[]'" :id="'barcode_access_levels_'+barcode.id+'_'+al.id" :val="al.id" v-model="barcode.access_levels"/>
              <div v-if="error.id == 'barcode_access_levels_'+barcode.id" class="form-error" v-for="error in errors">
                Kötelező
              </div>
            </td>
            <td valign="top">
              <inputbox @input="barcode.email_can_be_sent = false; barcode.selected = false;" :disabled="!barcode.editable" :datepicker="{enableTime: true}" style="width: 150px" :errors="errors" label="" :key="'barcode_start_date_time_'+barcode.id" :id="'barcode_start_date_time_'+barcode.id" v-model="barcode.start_date_time" />
            </td>
            <td valign="top">
              <inputbox @keyup="periodKeyup(barcode)" @input="barcode.email_can_be_sent = false; barcode.selected = false;" :disabled="!barcode.editable" style="width: 60px" regexp_filter="[0-9]+" :errors="errors" label="" :key="'barcode_period_'+barcode.id" :id="'barcode_period_'+barcode.id" v-model="barcode.period" />
            </td>
          </tr>
        </table>
      </div>
      <div v-else>
        Nem található vonalkód.
      </div>
    </div>
    <import-popup :request_id="$route.query.id" @close="popup.import = false" @success="getBarcodes" v-if="popup.import"/>
  </div>
</template>

<script>
import Vue from 'vue';
import ImportPopup from './import.vue';

export default {
  components: {
    ImportPopup
  },
  data() {
    return {
      popup: {
        import: false
      },
      barcodes: [],
      access_levels: [],
      errors: [],
      all_access_level_id: [],
      all_start_date_time: '',
      all_period: '',
      all_select: false
    };
  },
  watch: {
    all_select: function() {
      var _this = this;

      this.barcodes.map(function(barcode) {
        if (barcode.email_can_be_sent)
          barcode.selected = _this.all_select;
      });
    }
  },
  mounted: function() {
    this.getBarcodes();

    Vue.nextTick(function() {
      if (!$('.menu-column-sub').hasClass('hide') && $('.menu-column-sub2').hasClass('hide')) {
        $('.wrapper .content').css({'padding-left': '162px'});
      }

      if (!$('.menu-column-sub').hasClass('hide') && !$('.menu-column-sub2').hasClass('hide')) {
        $('.wrapper .content').css({'padding-left': 162 + $('.menu-column-sub2').outerWidth() });
      }

      if ($('.menu-column-sub').hasClass('hide') && $('.menu-column-sub2').hasClass('hide'))
        $('.wrapper .content').css({'padding-left': '100px'});
    });
  },
  methods: {
    periodKeyup: function(barcode) {
      if (parseInt(this.$root.user.barcode_period_fix) == 1) {
        barcode.period = 24;
      }
    },

    visibleAllSelect: function() {
      var r = false;
      this.barcodes.map(function(barcode) {
        if (barcode.email_can_be_sent)
          r = true;
      });
      return r;
    },

    hasSelect: function() {
      var s = false;
      this.barcodes.map(function(barcode) {
        if (barcode.selected)
          s = true;
      });
      return s;
    },

    allAccessLevelChange: function() {
      var _this = this;

      this.barcodes.map(function(barcode) {
        if (barcode.editable) {
          barcode.access_levels = [];
          _this.all_access_level_id.map(function(id) {
            barcode.access_levels.push(id);
          });
        }
      });
    },

    allStartDateTimeChange: function(ov, nv) {
      var _this = this;

      this.barcodes.map(function(barcode) {
        if (barcode.editable)
          barcode.start_date_time = _this.all_start_date_time;
      });
    },

    allPeriodChange: function() {
      var _this = this;

      this.barcodes.map(function(barcode) {
        if (barcode.editable)
          barcode.period = _this.all_period;
      });
    },

    save: function() {
      var _this = this;
      this.$emit('save_start');

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('barcodesUpdate/' + _this.$root.user.apikey, {
          method: 'POST',
          waitForSaveInfo: true,
          data: {
            barcodes: JSON.stringify(_this.barcodes)
          },
          success: function(response) {
            _this.errors = [];
            _this.$emit('save_finish');

            if (response.errors != undefined) {
              _this.errors = response.errors;
            } else {
              _this.getBarcodes();
            }
          }
        });
      });
    },

    mail: function() {
      var _this = this;
      this.errors = [];

      this.$emit('save_start');

      this.$root.ajax('barcodeSendEmail/' + _this.$root.user.apikey, {
        method: 'POST',
        waitForSaveInfo: true,
        data: {
          barcodes: JSON.stringify(this.barcodes)
        },
        success: function(response) {
          _this.errors = [];
          _this.$emit('save_finish');

          if (response.errors != undefined) {
            _this.errors = response.errors;
          } else {
            _this.getBarcodes();
            _this.all_select = false;
          }
        }
      });
    },

    getBarcodes: function() {
      var _this = this;

      if (this.$route.query.id != undefined) {
        this.$root.checkRootUserHasSet(function() {
          _this.$root.ajax('barcodesToSet/' + _this.$root.user.apikey + '/' + _this.$route.query.id, {
            success: function(response) {
              _this.barcodes = response.barcodes;
              _this.access_levels = response.access_levels;
            }
          });
        });
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// setup.vue?ebeb32a2